if (!customElements.get('accordion-group')) {
  customElements.define(
    'accordion-group',
    class AccordionGroup extends HTMLElement {
      connectedCallback() {
        this.addEventListener('toggle', this.onToggle, true);
        this.enforceSingleOpen();
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
      }

      enforceSingleOpen() {
        const open = this.querySelectorAll('details[open]');
        open.forEach((details, index) => {
          if (index > 0) details.open = false;
        });
      }

      onToggle = (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;

        this.querySelectorAll('details[open]').forEach((other) => {
          if (other === details) return;
          const host = other.closest('collapsible-content');
          if (host && typeof host.collapse === 'function') {
            host.collapse();
          } else {
            other.open = false;
          }
        });
      };
    }
  );
}
